<template>
<div class="chapter">
<div class="inner_page">
<section class="level1 hidden" data-number="1" epub:type="dedication" id="dedication">
<h1 class="hidden" data-number="1" epub:type="dedication">Dedication</h1>
<p>To the treehouse, for your shelter and for keeping out all those pesky distractions</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?a9a144cc